import type { AppLogoProps } from "./app-logo.type";

import { Link } from "react-router";

import "./app-logo.style.less";

const path = "/logo.light.svg";

export const AppLogo = ({ withLink }: AppLogoProps) => {
  return (
    <div className="stelar-logo">
      {withLink ? (
        <Link to="/">
          <img src={path} />
        </Link>
      ) : (
        <img src={path} />
      )}
    </div>
  );
};
